import { render, staticRenderFns } from "./AuthRegistration.vue?vue&type=template&id=1e4d219a"
import script from "./AuthRegistration.vue?vue&type=script&lang=js"
export * from "./AuthRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports